const getDeviceOS = (useragent = '') => {
  const osList = [{
    name: 'android',
    regex: /Android/i
  }, {
    name: 'ios',
    regex: /iPad|iPhone|iPod/i
  }, {
    name: 'mac',
    regex: /Mac/i
  }, {
    name: 'windows',
    regex: /Windows/i
  }];
  return osList.find(({
    regex
  }) => regex.test(useragent))?.name ?? 'unknown';
};
function getDeviceContext(options = {}) {
  const {
    type = '',
    name = 'other',
    parser = {}
  } = options;
  let initialMediaType;
  switch (type) {
    case 'tablet':
      initialMediaType = 'sm';
      break;
    case 'desktop':
      initialMediaType = 'lg';
      break;
    // mobile first!
    // Assue everything is a phone unless you are told its not
    default:
      initialMediaType = 'xs';
  }
  return {
    initialMediaType,
    initialOrientation: type === 'phone' ? 'portrait' : 'landscape',
    browser: parser.useragent?.family,
    version: parser.useragent?.major,
    name,
    os: getDeviceOS(parser.useragent?.source),
    type
  };
}

export { getDeviceContext };
